class App{
    constructor(){}

    init( _option ){
        this.option = jQuery.extend(true, {
            apiUrl: '',
            selector : '#autoSuggest',
            service: '',
            alias: '',
            submitCallback: _q => console.log( 'query :', _q, '::: option.submitCallback 설정은 필수 입니다' ),
            size: 10,
            useDelbtn: false,
            addParam: {}
        }, _option);

        this.loadedKeyword = '';
        this.dataBaseKeyword = '';
        this.isValueFunctionText = '';
        this.apiUrl = this.setApiUrl();
        this.suggestWrap = jQuery(this.option.selector + " [data-name='suggest_wrap']").hide();
        this.input = jQuery(this.option.selector + " [data-name='suggest_input']");
        this.submitBtn = jQuery(this.option.selector + " [data-name='suggest_submit']");
        this.deleteBtn = jQuery(this.option.selector + " [data-name='suggest_delete']").hide();
        this.resultUL = jQuery(this.option.selector + " [data-name='suggest_scroll'] ul");

        this.addEvents();
    }

    setApiUrl(){
        let url = '';
        if(!this.option.apiUrl){
            let env = location.href.match(/(rc\.|rc\-)/i)? location.href.match(/(rc\.|rc\-)/i)[1]: 'live';
                env = (/local\.|localhost\.|opdev\.|ui-static\.|file:/i.test(location.href))? 'opdev': env;
            const apiDomains = {
                'opdev' : 'http://opdev-searchsuggest.plaync.com',
                'rc.'   : 'https://rc-searchsuggest.plaync.com',
                'rc-'   : 'https://rc-searchsuggest.plaync.com',
                'live'  : 'https://searchsuggest.plaync.com'
            };
            
            url = apiDomains[env] + `/suggest/${this.option.service}/v1.0/${this.option.alias}`;
        }else{
            url = this.option.apiUrl;
        }

        return url;
    }

    load(_newKeyword){
        if(this.ajaxCall && this.ajaxCall.abort) this.ajaxCall.abort();

        this.loadedKeyword = _newKeyword;
        let params = jQuery.extend( true, {query: this.loadedKeyword.replace( /\s*/g, '' ), page_size: this.option.size}, this.option.addParam );

        this.ajaxCall = jQuery.ajax({
            url: this.apiUrl,
            xhrFields: {withCredentials: true}, dataType: "json", type: "GET",
            data: jQuery.param(params)
        })
        .done( _data => this.drawList(_data) )
        .fail( e => console.log('::::::::::fail::::::::::', e) );
    }

    addEvents(){
        let eventType = (window._device && window._device==='ingame')? 'keypress': 'keydown';
        this.input.on(eventType+'.autoSuggest', (e)=>{
            if ( e.keyCode === 27 ) { // ESC
                this.input.val(this.loadedKeyword);
                this.suggestWrapToggle(false);
                return false;
            }

            if ( e.keyCode === 13 ) { // Enter
                this.submitGo();
                return false;
            }

            if ( e.keyCode === 9 ) { // Tab
                this.focusChange( !e.shiftKey? 1: -1 );
                return false;
            }

            if ( e.keyCode === 40) { // ↓
                this.focusChange(1);
                return false;
            }

            if ( e.keyCode === 38 ) { // ↑
                this.focusChange(-1);
                return false;
            }
        });

        this.input.on( 'focusout', e => {
            setTimeout( () => this.suggestWrapToggle(false) , 150 );
        });

        this.input.on( 'focusin', e => {
            this.isValueFunctionText = '';
            if( !this.sto ) this.realTimeInputCheck();
            if( this.resultUL.find('li').length ) this.suggestWrapToggle(true);
        });

        this.submitBtn.on( 'click', e => this.submitGo() );

        this.deleteBtn.on( 'click', e => {
            this.loadedKeyword = '';
            this.input.val( '' ).focus();
        });

        this.resultUL.on( 'mouseover', 'li', e => {
            this.resultUL.find('li').removeClass('focus');
            jQuery(e.currentTarget).addClass('focus');
        });
    }

    realTimeInputCheck(){
        if(this.sto){
            clearTimeout( this.sto );
            this.sto = null;
        }

        const inputTxt = this.input.val().trim();

        // 문자열이 있나?
        if( inputTxt ){
            // 바로 앞에서 api 호출한 문자열 인가?
            // 화살표 이동을 통해 입력된 문자열 인가?
            if( this.loadedKeyword !== inputTxt && this.dataBaseKeyword !== inputTxt && this.isValueFunctionText !== inputTxt ){
                this.load( inputTxt );
                this.isValueFunctionText = '';
            }
        } else {
            if(this.loadedKeyword != '') {
                setTimeout(()=>{
                    if( this.input.val().trim() ) return;
                    this.loadedKeyword = '';
                }, 10);
            }
            if(this.resultUL.html() != '') {
                setTimeout(()=>{
                    this.resultUL.html('');
                    this.suggestWrapToggle(false);
                }, 10);
            }
        }

        this.deleteBtnToggle(inputTxt);
        this.sto = setTimeout(()=>this.realTimeInputCheck(), 10);
    }

    deleteBtnToggle(inputTxt = ''){
        if(!this.option.useDelbtn) return false;

        if(inputTxt){
            if(!this.deleteBtnIsShow){
                this.deleteBtn.show();
                this.deleteBtnIsShow = true;
            }
        }else{
            if(this.deleteBtnIsShow){
                this.deleteBtn.hide();
                this.deleteBtnIsShow = false;
            }
        }
    }

    drawList(_data){
        if(!this.input.val().trim()) return; // 인풋에 문자열 없으면 데이터가 들어와도 보여주지 않는다.

        this.suggestWrapToggle(_data.front.length>0);
        this.listRemoveEvent();

        let list = '';
        if(_data.front.length){
            let reg = new RegExp(this.loadedKeyword, 'i');
            list = _data.front.map( (item, idx) => {
                const regStr = reg.exec(item.keyword);
                const str = item.keyword.replace(regStr, `<mark>${regStr}</mark>`);
                return `<li data-idx="${idx}" data-keyword="${item.keyword}">${str}</li>`; 
            } ).join('');
        }
        this.resultUL.html(list);
        this.listAddEvent();
    }

    listRemoveEvent(){
        jQuery( this.option.selector + " [data-name='suggest_scroll'] ul li" ).off('click');
    }

    listAddEvent(){
        jQuery( this.option.selector + " [data-name='suggest_scroll'] ul li" ).on('click', e => {
            this.input.val( jQuery(e.currentTarget).data('keyword') );
            this.submitGo();
        });
    }

    focusChange( _direction = 1 ){
        let newFocusEl;
        let oldFocusEl = this.resultUL.find('.focus');

        if(_direction === 1){
            newFocusEl = ( oldFocusEl.length )? oldFocusEl.next(): this.resultUL.find('li').first();
        }
        if(_direction === -1){
            newFocusEl = ( oldFocusEl.length )? oldFocusEl.prev(): this.resultUL.find('li').last();
        }

        this.resultUL.find('li').removeClass('focus');

        this.suggestWrapToggle(newFocusEl.length>0);

        if( newFocusEl.length ){
            newFocusEl.addClass('focus');
            this.dataBaseKeyword = newFocusEl.data('keyword');
            this.input.val( this.dataBaseKeyword );
        }
    }

    submitGo() {
        this.suggestWrapToggle(false);
        if (typeof this.option.submitCallback === 'function' && this.input.val().trim() !== '') {
            this.option.submitCallback( this.input.val().trim() );
        }
    }

    suggestWrapToggle(_isShow=true){
        this.suggestWrap.toggle(_isShow);
        if(!_isShow) this.resultUL.find('li').removeClass('focus');
    }

    // public ---------------------------------------------------------------------
    changeAddParam(_param){
        this.option.addParam = _param;
    }

    value(_txt){
        this.isValueFunctionText = _txt;
        this.input.val(_txt);
    }

}

window.AutoSuggest = App;

export default App;



// WEBPACK FOOTER //
// ./App.js